<template>
  <div class="manager-company">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>公司管理</span>
        </div>
      </template>

      <!-- 搜索表单 -->
      <el-form :inline="true" :model="queryParams" class="search-form">
        <el-form-item label="企业名称">
          <el-input
            v-model="queryParams.companyName"
            placeholder="请输入企业名称"
            clearable
            @keyup.enter="handleSearch"
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item label="企业编码">
          <el-input
            v-model="queryParams.companyCode"
            placeholder="请输入企业编码"
            clearable
            @keyup.enter="handleSearch"
            style="width: 200px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 企业列表 -->
      <el-table
        v-loading="loading"
        :data="companyList"
        border
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="companyCode" label="企业编码" width="120" />
        <el-table-column prop="companyName" label="企业名称" width="200" />
        <el-table-column prop="companyShortName" label="企业简称" width="150" />
        <el-table-column prop="creditCode" label="统一社会信用代码" width="180" />
        <el-table-column prop="legalPerson" label="公司法人" width="120" />
        <el-table-column prop="phone" label="联系电话" width="130" />
        <el-table-column prop="email" label="邮箱" width="180" />
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template #default="{ row }">
            {{ formatDateTime(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="{ row }">
            <el-button type="primary" size="small" @click="handleView(row)">详情</el-button>
            <el-button type="warning" size="small" @click="handleEdit(row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          v-model:current-page="queryParams.page"
          v-model:page-size="queryParams.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>

    <!-- 企业详情/编辑对话框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="dialogTitle"
      width="800px"
      @close="handleDialogClose"
    >
      <el-form
        ref="companyFormRef"
        :model="companyForm"
        :rules="companyFormRules"
        label-width="140px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业编码">
              <el-input v-model="companyForm.companyCode" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="companyName">
              <el-input v-model="companyForm.companyName" :disabled="isViewMode" placeholder="请输入企业名称" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业简称">
              <el-input v-model="companyForm.companyShortName" :disabled="isViewMode" placeholder="请输入企业简称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码">
              <el-input v-model="companyForm.creditCode" :disabled="isViewMode" placeholder="请输入统一社会信用代码" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="公司法人">
              <el-input v-model="companyForm.legalPerson" :disabled="isViewMode" placeholder="请输入公司法人" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="companyForm.phone" :disabled="isViewMode" placeholder="请输入联系电话" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="邮箱">
              <el-input v-model="companyForm.email" :disabled="isViewMode" placeholder="请输入邮箱" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司Logo">
              <el-input v-model="companyForm.logo" :disabled="isViewMode" placeholder="Logo URL" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公司地址">
              <el-input
                v-model="companyForm.address"
                type="textarea"
                :rows="2"
                :disabled="isViewMode"
                placeholder="请输入公司地址"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="公司描述">
              <el-input
                v-model="companyForm.description"
                type="textarea"
                :rows="3"
                :disabled="isViewMode"
                placeholder="请输入公司描述"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">{{ isViewMode ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!isViewMode" type="primary" @click="handleSubmit">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { getCurrentCompany, updateCurrentCompany } from '../api/managerCompany'

// 数据
const loading = ref(false)
const companyList = ref([])
const total = ref(0)
const queryParams = reactive({
  companyName: '',
  companyCode: '',
  page: 1,
  pageSize: 10
})

// 对话框
const dialogVisible = ref(false)
const dialogTitle = ref('企业详情')
const isViewMode = ref(false)
const companyFormRef = ref(null)
const companyForm = reactive({
  id: null,
  companyCode: '',
  companyName: '',
  companyShortName: '',
  creditCode: '',
  legalPerson: '',
  address: '',
  phone: '',
  email: '',
  logo: '',
  description: ''
})

const companyFormRules = {
  companyName: [
    { required: true, message: '请输入企业名称', trigger: 'blur' }
  ]
}

// 方法
const formatDateTime = (dateTime) => {
  if (!dateTime) return '-'
  const date = new Date(dateTime)
  return date.toLocaleString('zh-CN')
}

const loadCompanyList = async () => {
  loading.value = true
  try {
    // 管理员只能查看自己所属的企业
    const res = await getCurrentCompany()
    if (res.code === '000000' && res.data) {
      let companies = [res.data]
      
      // 如果设置了搜索条件，进行前端过滤
      if (queryParams.companyName || queryParams.companyCode) {
        companies = companies.filter(company => {
          const matchName = !queryParams.companyName || 
            (company.companyName && company.companyName.includes(queryParams.companyName))
          const matchCode = !queryParams.companyCode || 
            (company.companyCode && company.companyCode.includes(queryParams.companyCode))
          return matchName && matchCode
        })
      }
      
      companyList.value = companies
      total.value = companies.length
    } else {
      companyList.value = []
      total.value = 0
    }
  } catch (error) {
    console.error('获取企业信息失败:', error)
    ElMessage.error(error.response?.data?.message || '获取企业信息失败')
    companyList.value = []
    total.value = 0
  } finally {
    loading.value = false
  }
}

const handleSearch = () => {
  queryParams.page = 1
  loadCompanyList()
}

const handleReset = () => {
  queryParams.companyName = ''
  queryParams.companyCode = ''
  queryParams.page = 1
  loadCompanyList()
}

const handleView = async () => {
  try {
    // 使用当前企业接口获取详情
    const res = await getCurrentCompany()
    if (res.code === '000000' && res.data) {
      dialogTitle.value = '企业详情'
      isViewMode.value = true
      Object.assign(companyForm, {
        id: res.data.id,
        companyCode: res.data.companyCode || '',
        companyName: res.data.companyName || '',
        companyShortName: res.data.companyShortName || '',
        creditCode: res.data.creditCode || '',
        legalPerson: res.data.legalPerson || '',
        address: res.data.address || '',
        phone: res.data.phone || '',
        email: res.data.email || '',
        logo: res.data.logo || '',
        description: res.data.description || ''
      })
      dialogVisible.value = true
    }
  } catch (error) {
    console.error('获取企业详情失败:', error)
    ElMessage.error(error.response?.data?.message || '获取企业详情失败')
  }
}

const handleEdit = async () => {
  try {
    // 使用当前企业接口获取详情
    const res = await getCurrentCompany()
    if (res.code === '000000' && res.data) {
      dialogTitle.value = '编辑企业'
      isViewMode.value = false
      Object.assign(companyForm, {
        id: res.data.id,
        companyCode: res.data.companyCode || '',
        companyName: res.data.companyName || '',
        companyShortName: res.data.companyShortName || '',
        creditCode: res.data.creditCode || '',
        legalPerson: res.data.legalPerson || '',
        address: res.data.address || '',
        phone: res.data.phone || '',
        email: res.data.email || '',
        logo: res.data.logo || '',
        description: res.data.description || ''
      })
      dialogVisible.value = true
    }
  } catch (error) {
    console.error('获取企业详情失败:', error)
    ElMessage.error(error.response?.data?.message || '获取企业详情失败')
  }
}

const handleSubmit = async () => {
  if (!companyFormRef.value) return
  await companyFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        // 使用当前企业更新接口
        const res = await updateCurrentCompany(companyForm)
        if (res.code === '000000') {
          ElMessage.success('保存成功')
          dialogVisible.value = false
          loadCompanyList()
        }
      } catch (error) {
        console.error('保存失败:', error)
        ElMessage.error(error.response?.data?.message || '保存失败')
      }
    }
  })
}

const handleDialogClose = () => {
  companyFormRef.value?.resetFields()
}

const handleSizeChange = (val) => {
  queryParams.pageSize = val
  queryParams.page = 1
  loadCompanyList()
}

const handlePageChange = (val) => {
  queryParams.page = val
  loadCompanyList()
}

onMounted(() => {
  loadCompanyList()
})
</script>

<style scoped>
.manager-company {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
}

.search-form {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
</style>
